import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Step from './Step/Step.js';
import classes from './StepList.module.scss.js';

const StepList = ({ steps = [], active = 0, className = "", }) => {
    const { t } = useTranslation("monorepo-noku-library");
    const stepsList = useMemo(() => steps.map((step, index) => jsx("div", { className: classes.step, children: jsx(Step, { circleClassName: (index + 1) < steps?.length ? classes.circle : "", isActive: (index + 1) === active, isDone: (index + 1) < active, stepNumber: index + 1, title: step.title || t(step.translation) }) }, step.key)), [steps, active, t]);
    return (jsx("div", { className: cx(classes.stepList, className), children: stepsList }));
};

export { StepList as default };
